import { useLabelVersion } from '../../../../features/labels/LabelsProvider';
import { labelId } from '../../../../features/labels/labels';
import React, { useMemo, useState } from 'react';
import {Grid,Box,FormGroup,FormControl,FormControlLabel,Checkbox,Select,MenuItem,InputLabel,Typography,Tabs,Tab,Button,Tooltip} from '@mui/material';
import {BarChartPPAandNV,BarChartTONandA,SfrChart,RadarChart,PolarAreaChart,AdvancedPolarChart} from '../../Components/Charts';
import {  handleLegendClick } from '../../Components/Charts/Polar/utils/polarChartUtils';
import { ALL_METRICS } from '../../Components/constants/constantsAnalytic';
import { getScappCompareKey, isSameScappSelection } from '../../utils/compareSelection';
// import { CalendarioAnalitica } from '../../Components/Calendario';
import '../../Components/Charts/styles/Dashboard.css';

// Lista de colores para asignar a cada centro (índice 0 → 'rgb(99, 132, 255)', índice 1 → 'rgb(255, 159, 64)', etc.)
const colorCentro = [
  'rgb(99, 132, 255)',
  'rgb(255, 159, 64)',
  'rgb(153, 102, 255)',
  'rgb(75, 192, 192)',
  'rgb(255, 205, 86)',
];



// Mapeo de clave → componente de gráfico
const chartComponents = {
  sfr: SfrChart,
  ton:   BarChartTONandA,
  ppa:   BarChartPPAandNV,
};

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`chart-tabpanel-${index}`}
      aria-labelledby={`chart-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `chart-tab-${index}`,
    'aria-controls': `chart-tabpanel-${index}`,
  };
}

const MenuComparativo = ({
  selectedCenters,
  setSelectedCenters,
  versus,
  dias,
  setDias,
  nivelSeleccionado,
  data,
  alarmGraph, setAlarmGraph,
  translate

}) => {
  useLabelVersion();
  const t = (key, fallback, params) => {
    const value = typeof translate === 'function' ? translate(key, params) : key;
    return value && value !== key ? value : fallback;
  };
  const metricLabel = (metric) => {
    if (!metric) return '';
    const map = {
      delivered_food: ['delivered_food', 'Alimento entregado'],
      sfr_value: ['average_sfr', 'SFR'],
      alarms_count: ['alarms', 'Alarmas'],
      perdidos_count: ['pellets_lost', 'PPA'],
      visitas_count: ['visits', 'Visitas'],
      alarms_by_ton: ['alarms_per_ton', 'Alarmas por tonelada'],
      alarms_by_visits: ['alarms_per_visit', 'Alarmas por visita'],
    };
    const [key, fallback] = map[metric.key] || [metric.key, metric.label];
    return t(key, fallback);
  };

  // Definición de tipos de gráfico para comparativas
  const chartTypes = [
    { key: 'sfr', label: 'SFR' },
    {
      key: 'ton',
      label: alarmGraph?.[1] === 'alarms_by_ton'
        ? `${t('alarms_per_ton', 'Alarmas por tonelada')} / ${t('alarms', 'Alarmas')}`
        : `${t('alarms_per_visit', 'Alarmas por visita')} / ${t('alarms', 'Alarmas')}`
    },
    { key: 'ppa', label: `PPA / ${t('visits', 'Visitas')}` },
  ];

  // “datos” contendrá el array de objetos con .name y .analytic_data (o .values_summary), según “nivelSeleccionado”

  // ---------- ESTADOS AdvancedPolarChart ----------
  const [excludedMetrics, setExcludedMetrics] = useState([]);
  const [hoverInfo, setHoverInfo] = useState(null);
  const [selectedInfo, setSelectedInfo] = useState(null);
  const [hoverDayInfo, setHoverDayInfo] = useState(null);

  // Normalizamos “items” en un array de: { name, analytic_data? y/o values_summary? }
  let items = [];
  if (nivelSeleccionado === 'area') {
    items = versus; // ya tiene .name y .analytic_data
  } else if (nivelSeleccionado === 'region') {
    items = versus;
  } else {
    // data.analytic_data es un objeto cuyas claves son las jaulas, cada valor tiene { name, values_summary }
    items = Object.values(data?.analytic_data || {});
  }

  const getSelectionKey = (value) => getScappCompareKey(value, nivelSeleccionado);
  const safeCenters = Array.isArray(selectedCenters) ? selectedCenters : [];
  const resolvedSelectedItems = useMemo(
    () =>
      safeCenters
        .map((selectedValue) =>
          items.find((item) =>
            isSameScappSelection(item?.name, selectedValue, nivelSeleccionado)
          )
        )
        .filter(Boolean),
    [items, nivelSeleccionado, safeCenters]
  );
  const selectedChartNames = useMemo(
    () => resolvedSelectedItems.map((item) => item.name),
    [resolvedSelectedItems]
  );
  const selectedSelectorOptions = useMemo(() => {
    const source = resolvedSelectedItems.length > 0 ? resolvedSelectedItems : items;
    const seen = new Set();

    return source.filter((item) => {
      const optionKey = getScappCompareKey(item?.name, nivelSeleccionado);

      if (!optionKey || seen.has(optionKey)) {
        return false;
      }

      seen.add(optionKey);
      return true;
    });
  }, [items, nivelSeleccionado, resolvedSelectedItems]);

  // Estado de pantallas de tabs (polar | radar)
  const [tabIndex, setTabIndex] = useState(0);
  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

 // Estado para filtrar las metricas
  const VISIBLE_METRICS = ALL_METRICS.filter((m) => m.vsMetrics);

  // Estado de métrica seleccionada para polar/radar (solo una a la vez)
  const [selectedMetric, setSelectedMetric] = useState(VISIBLE_METRICS[0].key);
    // Estado para alternar entre “mostrar todas las métricas” o “ver por días”
  const [showAllMetrics, setShowAllMetrics] = useState(false);
  
  // Filtramos métricas disponibles excluyendo 'sfr'
  const availableMetrics = VISIBLE_METRICS.filter((m) => m.key !== 'sfr_value');

  // const Metricas = tabIndex === 1 ? availableMetrics : metrics
  const Metricas = showAllMetrics ? VISIBLE_METRICS.filter((m) => m.key !== 'sfr_value') : VISIBLE_METRICS;


     // Estado de métricas seleccionadas en modo “todas las métricas”
  const [selectedMetricsKeys, setSelectedMetricsKeys] = useState(
    availableMetrics.map((m) => m.key)
  );

  const handleToggleMetric = (key) => {
    if(tabIndex === 1 && showAllMetrics){
      setSelectedMetricsKeys((prev) =>
        prev.includes(key)
          ? prev.filter((k) => k !== key)
          : [...prev, key]
      );
    }
    else if(tabIndex === 2){
       handleLegendClick(key, setExcludedMetrics, setHoverInfo, setSelectedInfo, setHoverDayInfo)
    }else{
      setSelectedMetric(prev => (prev === key ? '' : key));
    }
  };

  // **Nuevo**: Estado de “tipo de gráfico” cuando haya > 2 centros (sfr | ton | ppa)
  const [selectedChartType, setSelectedChartType] = useState(chartTypes[0].key);
  const handleChartTypeChange = (e) => {
    setSelectedChartType(e.target.value);
  };
  const ChartComponent = chartComponents[selectedChartType];

// 🔧 Función para normalizar nombres mal escritos en values_summary
const normalizeValueKeys = (value) => {
  if (value.hasOwnProperty("visitas_cout")) {
    value.visitas_count = value.visitas_cout;
    delete value.visitas_cout;
  }
  if (value.hasOwnProperty("perdidos_cout")) {
    value.perdidos_count = value.perdidos_cout;
    delete value.perdidos_cout;
  }
  return value;
};


  //  Función para obtener “jaulas” (values_summary) de un centro dado su nombre 
  const getJaulas = (name) => {
    const c = items.find(c => c.name === name);
    if (!c) return [];

    // Caso región
    if (nivelSeleccionado === 'region' && c.analytic_data) {
      const analyticData = c.analytic_data;
      const jaulas = [];

      const sampleValue = Object.values(analyticData)[0];
      const isFlat = sampleValue?.values_summary || sampleValue?.tasa_summary;

      if (isFlat) {
        // Caso plano: analytic_data contiene jaulas directamente
        for (const [jaulaId, jaula] of Object.entries(analyticData)) {
          const values_summary = jaula?.values_summary
            ? Object.entries(jaula.values_summary).map(([day, value]) => ({
                day,
                value: normalizeValueKeys({ ...value })
              }))
            : [];

          jaulas.push({
            name: jaula.name || jaulaId.split('-').pop(),
            label: labelId(jaulaId, 'rac', jaula.name || jaulaId.split('-').pop()),
            values_summary
          });
        }
      } else {
        // Caso anidado: analytic_data contiene zonas con jaulas
        for (const zona of Object.values(analyticData)) {
          for (const [jaulaId, jaula] of Object.entries(zona)) {
            const values_summary = jaula?.values_summary
              ? Object.entries(jaula.values_summary).map(([day, value]) => ({
                  day,
                  value: normalizeValueKeys({ ...value })
                }))
              : [];

            jaulas.push({
              name: jaula.name || jaulaId.split('-').pop(),
            label: labelId(jaulaId, 'rac', jaula.name || jaulaId.split('-').pop()),
              values_summary
            });
          }
        }
      }

      return jaulas;
    }

    //  Caso área
    if (nivelSeleccionado === 'area' && c.analytic_data) {
      return Object.values(c.analytic_data).map(jaula => ({
        ...jaula,
        values_summary: jaula.values_summary.map(entry => ({
          ...entry,
          value: normalizeValueKeys({ ...entry.value })
        }))
      }));
    }

    //  Caso centro
    if (c.values_summary) {
      return [
        {
          name: c.name,
          label: labelId(c.name, nivelSeleccionado === "region" ? "ra" : "rac", c.name),
          values_summary: [
            c.values_summary.map(entry => ({
              ...entry,
              value: normalizeValueKeys({ ...entry.value })
            }))
          ]
        }
      ];
    }

    return [];
  };
  // Particionamos selectedCenters en dos columnas: izquierda y derecha
  const leftCenters  = resolvedSelectedItems.filter((_, i) => i % 2 === 0);
  const rightCenters = resolvedSelectedItems.filter((_, i) => i % 2 === 1);

  // Control para cambiar el nombre de un centro (al hacer select en dropdown)
  const handleCenterChange = (oldName, newName) => {
    const nextKey = getSelectionKey(newName);
    setSelectedCenters((prev) => {
      const nextSelection = Array.isArray(prev) ? [...prev] : [];
      const currentIndex = nextSelection.findIndex((name) =>
        isSameScappSelection(name, oldName, nivelSeleccionado)
      );

      if (currentIndex === -1) {
        return prev;
      }

      const targetIndex = nextSelection.findIndex((name) =>
        isSameScappSelection(name, nextKey, nivelSeleccionado)
      );

      if (targetIndex !== -1 && targetIndex !== currentIndex) {
        [nextSelection[currentIndex], nextSelection[targetIndex]] = [
          nextSelection[targetIndex],
          nextSelection[currentIndex],
        ];
        return nextSelection;
      }

      nextSelection[currentIndex] = nextKey;
      return nextSelection;
    });
  };

  

  // Renderiza los tres gráficos (Sfr, TON+Alarmas, PPA+Visitas) para un solo “primer” centro
  const renderAllCharts = (item, colorIndex) => {
    const itemName = item?.name || '';
    const itemKey = getSelectionKey(itemName);
    const jaulas = getJaulas(itemName);
// console.log('jaulas',jaulas)
    return (
      <div
        className="card"
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '1vh',
          width: '100%',
        }}
        key={itemName}
      >
        {/* Selector de centro */}
        <CenterSelector
          value={itemKey}
          onChange={e => handleCenterChange(itemKey, e.target.value)}
          options={selectedSelectorOptions}
          nivelSeleccionado={nivelSeleccionado}
          translate={translate}
        />

        {/* Gráfico SFR */}
        <SfrChart
          InfoIconStyle={'.5vw'}
          SwapVertIconStyle={'-1.5vw'}
          nivelSeleccionado={nivelSeleccionado}
          chartData={jaulas}
          cardStyles={cardStyles}
          Leyendas={Leyendas}
          styleCardComparar={styleCardComparar}
          styleCardCompararSFR={styleCardComparar}
          // **Nuevo**: pasamos el color asignado a este centro
          color={colorCentro[colorIndex % colorCentro.length]}
          colorManual={true}
          invertVS={false}
          translate={translate}

        />

        {/* Gráfico TON + Alarmas */}
        <BarChartTONandA
          nivelSeleccionado={nivelSeleccionado}
          chartData={jaulas}
          cardStyles={cardStyles}
          Leyendas={Leyendas}
          styleCardComparar={styleCardComparar}
          color={colorCentro[colorIndex % colorCentro.length]}
          colorManual={true}
          alarmGraph={alarmGraph} setAlarmGraph={setAlarmGraph}
          marginRight={'-4vw'}
          marginLeft={'5.4vw'}
          iconLeft={'.3vw'}
          invertVS={false}
          translate={translate}
        />

        {/* Gráfico PPA + Visitas */}
        <BarChartPPAandNV
          nivelSeleccionado={nivelSeleccionado}
          chartData={jaulas}
          cardStyles={cardStyles}
          Leyendas={Leyendas}
          styleCardComparar={styleCardComparar}
          color={colorCentro[colorIndex % colorCentro.length]}
          colorManual={true}
          preset="ppa-nv"
          marginRight={'-4vw'}
          marginLeft={'5.4vw'}
          iconLeft={'.3vw'}
          invertVS={false}
          translate={translate}
        />
      </div>
    );
  };


  // Estilos para las tarjetas del dashboard
  const cardStyles = {
    small:   { display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', height: '25vh', width: '30.5vw', padding: '0.5vw', marginLeft: '0.5vw' },
    large:   { display: 'flex', border: 'solid 0.1vh rgba(126,121,121,0.38)', justifyContent: 'center', alignItems: 'center', alignContent: 'center', height: '25vh', width: '30vw', padding: '0.5vw', marginLeft: '-0.5vw' },
    ranking: { height: '93vh', width: '15.5vw', marginLeft: '0.5vw' },
  };
  const styleCardComparar = { maxHeight: '15vh', minHeight: '15vh', width: '29vw' };


  const AdvancedPolarChartProps = {
    excludedMetrics, setExcludedMetrics,
    hoverInfo, setHoverInfo,
    selectedInfo, setSelectedInfo,
    hoverDayInfo, setHoverDayInfo,
    versus: items,
    selected: selectedChartNames,
    colors:colorCentro,
    nivelSeleccionado,
    translate
  }


  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      style={{
        cursor: 'default !important',
        userSelect: 'none',
        height: '90vh',
        width: '100vw',
      }}
    >

      {/* ─────── Columna Izquierda ─────── */}
      <Grid
        container
        justifyContent="center"
        item
        xs={4}
        style={{
          maxWidth: '31.5vw',
          minHeight: '90vh',
          maxHeight: '90vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          marginRight: '1vw',
        }}
      >
        {
          // Si solo hay un centro en la columna izquierda
          leftCenters.length === 1
            ? renderAllCharts(leftCenters[0], 0)
            : leftCenters.map((item, idx) => {
                // Cuando hay más de uno, cada “tarjeta” es un único ChartComponent
                const itemName = item?.name || '';
                const itemKey = getSelectionKey(itemName);
                const jaulas = getJaulas(itemName);
                const colorIdx = idx * 2; // índice para colorCentro (0, 2, 4, ...)
                return (
                  <div
                    className="card"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '1vh',
                      width: '100%',
                    }}
                    key={itemName}
                  >
                    <div style={{display:'flex', justifyContent:'space-between'}}>
                      {/* Selector de centro con deshabilitado para evitar duplicados */}
                      <CenterSelector
                        value={itemKey}
                        onChange={e => handleCenterChange(itemKey, e.target.value)}
                        options={selectedSelectorOptions}
                        nivelSeleccionado={nivelSeleccionado}
                        translate={translate}
                      />

                      {/* 
                        **Nuevo**: Si es el PRIMER centro (índice 0 en leftCenters)
                        y hay más de dos centros en total, mostramos el dropdown
                        para elegir tipo de gráfico. 
                      */}
                      {safeCenters.length > 2 && idx === 0 && (
                        <FormControl
                          variant="standard"
                          size="small"
                          sx={{ width: '10vw', mb: '1vh' }}
                        >
                          <InputLabel id="select-chart-type">{t('chart', 'Grafico')}</InputLabel>
                          <Select
                            labelId="select-chart-type"
                            value={selectedChartType}
                            label={t('chart', 'Gráfico')}
                            onChange={handleChartTypeChange}
                          >
                            {chartTypes.map((ct) => (
                              <MenuItem key={ct.key} value={ct.key}>
                                {ct.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </div>
                    {/* Componente de gráfico dinámico (sfr, ton o ppa) */}
                    <ChartComponent
                      chartData={jaulas}
                      cardStyles={cardStyles}
                      Leyendas={Leyendas}
                      styleCardComparar={styleCardComparar}
                      styleCardCompararSFR={styleCardComparar}
                      nivelSeleccionado={nivelSeleccionado}
                      InfoIconStyle={'.5vw'}
                      SwapVertIconStyle={'-1.5vw'}
                      // pasamos el color de este centro
                      color={colorCentro[colorIdx % colorCentro.length]}
                      colorManual={true}
                      alarmGraph={alarmGraph} setAlarmGraph={setAlarmGraph}
                      marginRight={'-4vw'}
                      marginLeft={'5.4vw'}
                      iconLeft={'.3vw'}
                      invertVS={false}
                      translate={translate}

                    />
                  </div>
                );
              })
        }
      </Grid>



      {/* ─────── Columna Central ─────── */}
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        alignItems="center"
        item
        xs={4}
        style={{
          cursor: 'default !important',
          userSelect: 'none',
          height: '90vh',
          width: '100vw',
          // border:'solid 0.1vh'
        }}
      >
        {/* Calendario y Métricas */}
        <Grid item xs={12} container justifyContent="center" style={{ maxWidth: '35vw', minWidth: '35vw', marginTop:'0vh'
         }}>
         
          {/* Selección de Métricas para Radar/Polar */}
          <Grid item xs={12}  >
            <Box
              sx={{
                border: '0.01vw solid #e84e0e',
                borderRadius: '0.45vw',
                color: '#c3c3c3',
                minWidth: '32.8vw',
                maxWidth: '32.8vw',
                mb: '1vh',
                textAlign: 'center',
                marginLeft: '0.6vw',
                maxHeight: '15vh',
                minHeight: '15vh', 

              }}
            >
              <Typography component="h1" sx={{ fontSize: '1vw', color: '#c3c3c3', mt: '1vh', mb: '0.5vh',  }}>
                {t('metricas', 'Métricas')}
              </Typography>

              <FormGroup 
                sx={{
                  px: '1vw',
                  display: 'flex',
                  flexDirection: 'row',  
                  flexWrap: 'wrap',      
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '0.6vw',           
                  width: '100%',
                }}>
                {Metricas.map((m) => (
                  <FormControlLabel
                    key={m.key}
                    label={metricLabel(m)}
                    sx={{
                      '& .MuiFormControlLabel-label': { fontSize: '0.8vw' },
                      // marginBottom:'-1vh',
                      marginLeft:'-.75vw',
                      maxWidth:'9.5vw',
                      height:'2.5vh',
                    }}
                    control={
                      <Checkbox
                        checked={
                          tabIndex === 2
                            ? !excludedMetrics.includes(m.key)
                            : (tabIndex === 1 && showAllMetrics)
                              ? selectedMetricsKeys.includes(m.key)
                              : selectedMetric === m.key
                        }
                        onChange={() => handleToggleMetric(m.key)}
                        sx={{
                          '& .MuiSvgIcon-root': { fontSize: '.9vw' },
                          color: tabIndex === 2 ? m.color : '#c3c3c3',
                          '&.Mui-checked': {
                            color: tabIndex === 2 ? m.color : '#e84e0e'
                          },
                        }}
                      />
                    }
                  />
                ))}

                {tabIndex === 1 &&
                  <Button
                    variant='outlined'
                    onClick={() => setShowAllMetrics((prev) => !prev)}
                    style={{
                      fontSize: '.6vw',
                      height:'4vh',
                      width:'9vw',
                      padding:0,
                      cursor: 'pointer',
                      borderRadius: '.5vw',
                      marginTop:'1vh',
                      marginLeft:'-.5vw',
                      color:'#e84e0e',
                      borderColor:'#e84e0e'
                    }}
                  >
                    {showAllMetrics
                      ? t('see_by_days', 'Ver por días')
                      : t('see_all_metrics', 'Ver todas las métricas')}
                  </Button>
                }
              </FormGroup>

            </Box>
          </Grid>
        </Grid>

        {/* Tabs para Polar Area / Radar */}
        <Box sx={{ width: '50vw', ml: '-0.7vw', height: '74vh', overflowY: 'hidden',  }}>
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label={t('chart', 'Gráfico')}
            centered
            sx={{
              justifyContent: 'center',
              '& .MuiTabs-indicator': { backgroundColor: '#e84e0e' },
              height: '2vh', 
            }}
          >
           
            <Tab
              label={t('area_chart', 'Area')}
              {...a11yProps(0)}
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1vw',
                height: '3vh',
                color: 'gray',
                '&.Mui-selected': { color: '#c3c3c3' },
              }}
            />
            <Tab
              label={t('radar_chart', 'Radar')}
              {...a11yProps(1)}
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1vw',
                height: '3vh',
                color: 'gray',
                '&.Mui-selected': { color: '#c3c3c3' },
              }}
            />
             <Tab
              label={t('advanced_chart', 'Avanzado')}
              {...a11yProps(2)}
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1vw',
                height: '3vh',
                color: 'gray',
                '&.Mui-selected': { color: '#c3c3c3' },
              }}
            />
          </Tabs>

          <TabPanel value={tabIndex} index={2}>
            <Grid container>
              <Grid item xs={12}>
                <AdvancedPolarChart {...AdvancedPolarChartProps}/>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={tabIndex} index={0}>
            <Grid container>
              <Grid item xs={12}>
                <PolarAreaChart
                  versus={items}
                  metrics={ALL_METRICS}
                  selected={selectedChartNames}
                  selectedMetric={selectedMetric}
                  // **Nuevo**: pasamos todos los colores para que cada dataset (centro) use su color 
                  colors={colorCentro}
                  nivelSeleccionado={nivelSeleccionado}
                  translate={translate}
                />
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <Grid item xs={12}>
              <RadarChart
                versus={items}
                metrics={ALL_METRICS}
                selected={selectedChartNames}
                selectedMetric={selectedMetric}
                colors={colorCentro}
                showAllMetrics={showAllMetrics}
                availableMetrics={availableMetrics}
                selectedMetricsKeys={selectedMetricsKeys}
                nivelSeleccionado={nivelSeleccionado}

              />
            </Grid>
          </TabPanel>
        </Box>
      </Grid>



      {/* ─────── Columna Derecha ─────── */}
      <Grid
        container
        justifyContent="center"
        item
        xs={4}
        style={{
          maxWidth: '31.5vw',
          minHeight: '90vh',
          maxHeight: '90vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          marginRight: '1vw',
        }}
      >
        {
          rightCenters.length === 1
            ? renderAllCharts(rightCenters[0], 1)
            : rightCenters.map((item, idx) => {
                const itemName = item?.name || '';
                const itemKey = getSelectionKey(itemName);
                const jaulas = getJaulas(itemName);
                const colorIdx = idx * 2 + 1; // 1, 3, 5, ...
                return (
                  <div
                    className="card"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '1vh',
                      width: '100%',
                    }}
                    key={itemName}
                  >
                    {/* Selector de centro para la columna derecha */}
                    <CenterSelector
                      value={itemKey}
                      onChange={e => handleCenterChange(itemKey, e.target.value)}
                      options={selectedSelectorOptions}
                      nivelSeleccionado={nivelSeleccionado}
                      translate={translate}
                    />
                    <ChartComponent
                      chartData={jaulas}
                      cardStyles={cardStyles}
                      Leyendas={Leyendas}
                      styleCardComparar={styleCardComparar}
                      nivelSeleccionado={nivelSeleccionado}
                      styleCardCompararSFR={styleCardComparar}
                      InfoIconStyle={'.5vw'}
                      SwapVertIconStyle={'-1.5vw'}
                      color={colorCentro[colorIdx % colorCentro.length]}
                      translate={translate}
                      colorManual={true}
                      alarmGraph={alarmGraph} setAlarmGraph={setAlarmGraph}
                      marginRight={'-4vw'}
                      marginLeft={'5.4vw'}
                      iconLeft={'.3vw'}
                      invertVS={false}
                    />
                  </div>
                );
              })
        }
      </Grid>
    </Grid>
  );
};

export default MenuComparativo;



/* ─────────── Componentes Auxiliares ─────────── */

const Leyendas = ({ data, toggle, visible, sfrChart = false, translate }) => {
  const t = (key, fallback) => {
    const value = typeof translate === 'function' ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        height: '4.4vh',
        width: sfrChart ? '29vw' : '29vw',
        overflowY: 'auto'
      }}
    >
      {data?.datasets?.map((ds, index) => {
        const hasRealData = Array.isArray(ds.data) && ds.data.some((value) => value != null && value !== 0);
        const zeroOnly = !hasRealData && Array.isArray(ds.data) && ds.data.some((value) => value === 0);
        const node = (
          <div
            onClick={() => hasRealData && toggle(index)}
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '2vh',
              marginRight: '0.4vw',
              cursor: hasRealData ? 'pointer' : 'default',
              opacity: hasRealData || zeroOnly ? 1 : 0.5,
            }}
          >
            <div
              style={{
                backgroundColor: ds.backgroundColor,
                marginRight: '0.1vw',
                width: '1vw',
                height: '0.4vw'
              }}
            />
            <p
              style={{
                textDecoration: visible[index] ? 'none' : 'line-through',
                color: '#777',
                fontSize: '0.6vw'
              }}
            >
              {ds.label}
            </p>
          </div>
        );

        if (hasRealData) return node;
        if (zeroOnly) return <Tooltip key={index} title={t('zero_value', 'Valor 0')}>{node}</Tooltip>;
        return <Tooltip key={index} title={t('no_data', 'No hay datos')}>{node}</Tooltip>;
      })}
    </div>
  );
}


const CenterSelector = ({ value, onChange, options, nivelSeleccionado, translate }) => {
  const t = (key, fallback) => {
    const text = typeof translate === 'function' ? translate(key) : key;
    return text && text !== key ? text : fallback;
  };
  const getOptionKey = (name) => getScappCompareKey(name, nivelSeleccionado);
  
  return (
    <FormControl variant="standard" size="small" sx={{ width: '10vw', marginBottom: '2vh' }}>
      <InputLabel id={`select-centro`}>
        {nivelSeleccionado === 'area' ? t('center_label', 'Centro') : t('cage_label', 'Jaula')}
      </InputLabel>
      <Select
        labelId={`select-centro`}
        value={value}
        label={nivelSeleccionado === 'area' ? t('center_label', 'Centro') : t('cage_label', 'Jaula')}
        onChange={onChange}
      >
        {options.map(c => (
          <MenuItem
            key={c.name}
            value={getOptionKey(c.name)}
          >
            {labelId(c.name, nivelSeleccionado === 'region' ? 'ra' : 'rac', c.name)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
